import { FC } from "react";

import { CheckIcon } from "@theme/assets";
import { DropdownMenu, Link, Text, ThemeUIStyleObject, getThemeValue } from "@theme/components";
import { NavigationDataProps } from "@theme/types";

interface NavLangDropdownProps {
  languages: NavigationDataProps["languages"];
  currentLanguage: NavigationDataProps["currentLanguage"];
  originalPath: NavigationDataProps["originalPath"];
  sx?: ThemeUIStyleObject;
  className?: string;
}

export const NavLangDropdown: FC<NavLangDropdownProps> = ({
  languages,
  currentLanguage,
  originalPath,
  sx,
  className,
}) => {
  return (
    <DropdownMenu
      buttonLabel={currentLanguage}
      aria-label={`Language Dropdown, current language is ${currentLanguage}`}
      sx={{
        'button[data-dropdown-button="true"]': { textTransform: "uppercase" },
        ...sx,
        zIndex: 1,
      }}
      isLangDropdown={true}
      className={className}
    >
      <>
        {languages.map((lang) => {
          return (
            <Link
              key={lang}
              sx={{ variant: "links.default", pl: "s500", pr: "s300", my: "s100", mx: "s200" }}
              // Add lang prefix to original path if not en
              href={`${lang !== "en" ? `/${lang}` : ""}${originalPath}`}
            >
              <Text
                variant="sansBody01Regular"
                sx={{ position: "relative", textTransform: "uppercase" }}
              >
                {lang === currentLanguage && (
                  <CheckIcon
                    sx={{
                      color: "goldPrimary",
                      position: "absolute",
                      right: (t) => `calc(100% + ${getThemeValue(t, "space.s100")} )`,
                      width: 16,
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  />
                )}
                {lang}
              </Text>
            </Link>
          );
        })}
      </>
    </DropdownMenu>
  );
};
